import _ from "underscore";

const FilteredListDirective = function () {
    return {
        restrict: 'E',
        scope: {
            items: '<',
            filter: '<?',
            sizes: '@?'
        },
        template: '<div class="row"><div ng-repeat="item in filteredItems" class="col {{ sizes }}"><span title="{{ item.Tooltip }}">{{ item.Text }}</span></div></div>',
        link: function (scope, element, attrs) {
            scope.filteredItems = [];
            scope.sizes = scope.sizes || 's12 m6 l4';

            function updateFilteredItems() {
                var filter = (scope.filter || '').toLowerCase();

                if (!filter) {
                    scope.filteredItems = scope.items;
                } else {
                    scope.filteredItems = _.filter(scope.items || [], function (i: any) {
                        return (i.Text || '').toLowerCase().indexOf(filter) >= 0;
                    })
                }
            }

            scope.$watchGroup(["filter", "items"], updateFilteredItems);
        }
    }
};

export { FilteredListDirective };